import { useEffect, useEffectEvent } from 'react';
import { registerCloseHandler } from '@/router/backNavigation';
import { watchBack } from '@/router/watchBack';

export const useCloseOnBack = (isOpen: boolean, onClose: () => void) => {
  const close = useEffectEvent(onClose);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const unregister = registerCloseHandler(() => close());
    const stopWatching = watchBack(() => close());

    return () => {
      unregister();
      stopWatching();
    };
  }, [isOpen]);
};
